import React, { useCallback, useEffect, useState } from "react";
import Layout from "./Shared/Layout";
import { useSelector, useDispatch } from 'react-redux';
import { get_cart_Data } from "../redux/action";
import useRazorpay from "react-razorpay";
import { ToastContainer, toast } from "react-toastify";
import { API_URL } from "../_services/apiUrl";
import { get, post } from "../_services/apiService";
import SelectedAddress from "./Shared/SelectedAddress";
import CheckoutOrderSummary from "./Shared/CheckoutOrderSummary";
import { decryptData } from "../_services/encDnc";

const projectNo = process.env.REACT_APP_PROJECT_NO

const Checkout = () => {
    const loginId = Number(localStorage.getItem('loginId'));
    const existingItemDetails = JSON.parse(localStorage.getItem('itemDetail'));
    const existingCartItemDetail = JSON.parse(localStorage.getItem('cartItemDetail'));
    const [loading, setLoading] = useState(false);
    const [discountApplied, setDiscountApplied] = useState(false);
    const [discountAmount, setDiscountAmount] = useState(0);
    const [discountCode, setDiscountCode] = useState('');
    const [projectPaymentGateway, setProjectPaymentGateway] = useState([]);
    const [couponCode, setCouponCode] = useState('');
    const customReqId = Number(sessionStorage.getItem('customReqId'));
    const dispatch = useDispatch();

    const selectedAddressId = Number(localStorage.getItem('selectedAddressId'));
    const [userAddressByLoginAddressId, setUserAddressByLoginAddressId] = useState([]);

    const [cartData, setCartData] = useState([]);
    const reduxCartData = useSelector((state) => state.cartReducer.cart);

    const deliveryCharge = 0.00;

    const [totalQuantity, setTotalQuantity] = useState(0);

    useEffect(() => {
        const getTotalQuantity = () => {
            return cartData.reduce((acc, item) => acc + (item.quantity || 0), 0);
        };
        setTotalQuantity(getTotalQuantity());
    }, [cartData]);


    const getCouponCode = async () => {
        if (!couponCode) {
            toast.error("Please enter coupon code.");
            return;
        }

        try {
            const response = await get(API_URL?.GetDiscountByCouponcode, {
                pCouponCode: encodeURIComponent(couponCode),
                pAmount: cartTotal,
                pTotalItem: totalQuantity > 0 ? totalQuantity : ''
            });
            if (response.isSuccess === 200) {
                toast.success(response.message)
                setDiscountAmount(response?.data?.discountAmount);
                setDiscountCode(response?.data?.couponCode);
                setDiscountApplied(true);
                setProductFormData(prevData => ({
                    ...prevData,
                    discount: response?.data?.discountAmount,
                    discountCode: response?.data?.couponCode
                }));
                setCouponCode('');
            } else {
                if (response.isSuccess === 404)
                    toast.error(response.message);
                setDiscountApplied(false);
            }
        } catch (error) {
            toast.error("Invalid Coupon Code");
            setDiscountApplied(false);
        } finally {
            setLoading(false);
        }
    };

    const cartItems = reduxCartData.map(item => ({
        skuId: item?.skuId || 0,
        cartItemId: item.cartItemId || 0,
        productId: item.productId || 0,
        loginId: loginId ? Number(loginId) : 0,
        buyStatus: item.buyStatus || 0,
        quantity: item.quantity || 1,
        unitPrice: item.unitPrice || 0,
        totalAmount: item.unitPrice ? item.unitPrice * item.quantity : 0,
        taxId: item?.taxId || 0,
        taxAmount: item?.taxAmount || 0
    }));
    // const items = items.filter(item => item.buyStatus === 1)

    useEffect(() => {
        const items = existingItemDetails?.length > 0
            ? existingItemDetails
            : existingCartItemDetail?.length > 0
                ? existingCartItemDetail
                : cartItems;

        if (JSON.stringify(items) !== JSON.stringify(cartData)) {
            setCartData(items);
        }
    }, [existingItemDetails, existingCartItemDetail, cartItems, cartData]);

    useEffect(() => {
        const fetchCartData = async () => {
            try {
                await dispatch(get_cart_Data());
            } catch (error) {
                toast.error("Failed to fetch cart data");
            } finally {
                setLoading(false);
            }
        };

        fetchCartData();
    }, [dispatch]);

    // cart total calculation
    const cartTotal = cartData?.map(item => {
        return customReqId ? item.unitPrice * item.quantity + 200 : item.unitPrice * item.quantity;
    }).reduce((preVal, curVal) => {
        return preVal + curVal;
    }, 0);

    const subtotal = typeof cartTotal === 'number' ? cartTotal.toFixed(2) : '0.00';
    const totalAmount = parseFloat(subtotal) + deliveryCharge - (discountApplied ? discountAmount : 0);

    useEffect(() => {
        const cartTotal = cartData?.map(item => {
            return customReqId ? item.unitPrice * item.quantity + 200 : item.unitPrice * item.quantity;
        }).reduce((preVal, curVal) => {
            return preVal + curVal;
        }, 0);

        const subtotal = typeof cartTotal === 'number' ? cartTotal.toFixed(2) : '0.00';
        const totalAmount = parseFloat(subtotal) + deliveryCharge - (discountApplied ? discountAmount : 0);

        setProductFormData((prevData) => ({
            ...prevData,
            orderAmount: totalAmount.toFixed(2),
        }));
    }, [cartData, deliveryCharge, discountAmount, discountApplied, customReqId]);

    // data of send on create order function for payment gateway
    const [productFormData, setProductFormData] = useState({
        addressId: selectedAddressId,
        orderId: 0,
        loginId: loginId,
        shippingCharge: deliveryCharge,
        discount: discountAmount ? discountAmount : 0,
        discountCode: discountCode ? discountCode : '',
        referralCode: "",
        orderAmount: Number(totalAmount.toFixed(2)),
        paymentGatewayTypeId: 1,
        projectNo: projectNo,
        itemDetail: [],
        customOrderId: customReqId
    });

    // Handle payment method change
    const handlePaymentMethodChange = (event) => {
        const selectedPaymentMethod = parseInt(event.target.value);
        // setSelectedPaymentMethodId(parseInt(event.target.value));
        if (selectedPaymentMethod === 3) {
            setDiscountAmount(0);
            setDiscountCode('');
            setDiscountApplied(false);
            setProductFormData(prevData => ({
                ...prevData,
                discount: 0,
                discountCode: '',
                paymentGatewayTypeId: selectedPaymentMethod,
            }));
        } else {
            setProductFormData((prevData) => ({
                ...prevData,
                paymentGatewayTypeId: selectedPaymentMethod
            }));
        }
    };

    const [Razorpay] = useRazorpay();

    const onCreateOrder = async () => {
        setLoading(true);

        try {
            const response = await post(API_URL?.SaveProductOrder, {
                orderId: productFormData.orderId,
                loginId: productFormData.loginId,
                shippingCharge: productFormData.shippingCharge,
                discount: productFormData.discount,
                discountCode: productFormData.discountCode,
                referralCode: productFormData.referralCode,
                orderAmount: productFormData.orderAmount,
                paymentGatewayTypeId: productFormData.paymentGatewayTypeId,
                addressId: productFormData.addressId,
                projectNo: productFormData.projectNo,
                itemDetail: cartData,
                customOrderId: productFormData?.customOrderId,
                isActive: true,
                createdBy: 0,
            });

            if (response.isSuccess === 1) {
                const result = response.data;
                // phonepe paymentgateway 
                if (productFormData.paymentGatewayTypeId === 2) {

                    const redirectUrl = result.data.url;

                    window.location.href = redirectUrl;

                }
                // razorpay paymentgateway
                else if (productFormData.paymentGatewayTypeId === 1) {
                    loadRazorpayScript();
                    const options = {
                        key: result.key,
                        amount: result.amount,
                        currency: result.currency,
                        name: result.name,
                        description: result.description,
                        image: result.image,
                        order_id: result.order_id,
                        prefill: result.prefill,
                        theme: result.theme,
                        callback_url: result.callback_url,
                        notes: result.notes
                    };
                    const paymentObject = new Razorpay(options);
                    paymentObject.open();
                }

                // cash on delivery
                else if (productFormData.paymentGatewayTypeId === 3) {
                    const redirectUrl = result.url;

                    window.location.href = redirectUrl;
                }
            }
        } catch (error) {
            toast.error("Payment Failed. Please try again later.");
        } finally {
            setLoading(false);
            setDiscountApplied(false);
            setDiscountAmount(0);
            setDiscountCode('');
        }
    };

    const loadRazorpayScript = async () => {
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.async = true;
        document.body.appendChild(script);
    }

    const fetchProjectPaymentGatewayByProjectId = useCallback(async () => {
        if (loginId) {
            try {
                const response = await get(`${API_URL?.GetProjectPaymentGatewayByProjectNo}?pProjectNo=${projectNo}`);
                if (response.isSuccess === 200) {
                    setProjectPaymentGateway(response.data);
                }
            } catch (error) {
                toast.error(error.response?.data?.message || "Please try again later.");
            }
        }
    }, [loginId]);

    useEffect(() => {
        fetchProjectPaymentGatewayByProjectId();
    }, [fetchProjectPaymentGatewayByProjectId]);

    const removeCoupon = () => {
        setDiscountAmount(0);
        setDiscountCode('');
        setDiscountApplied(false);
        toast.success('Removed Coupon Code');
        setProductFormData(prevData => ({
            ...prevData,
            discount: 0,
            discountCode: ''
        }));
    }

    const fetchUserAddressByLoginAddressId = useCallback(async () => {
        if (loginId) {
            try {
                const response = await get(`${API_URL?.GetUserAddressByLoginAddressId}?pLoginId=${loginId}&pAddressId=${selectedAddressId}`);
                const encryptedData = response.data;
                const result = decryptData(encryptedData);
                if (response.isSuccess === 200) {
                    setUserAddressByLoginAddressId(result[0]);
                } else {
                    setUserAddressByLoginAddressId([]);
                }
            } catch (error) {
                setUserAddressByLoginAddressId([]);
            }
        }
    }, [loginId, selectedAddressId]);

    useEffect(() => {
        fetchUserAddressByLoginAddressId();
    }, [fetchUserAddressByLoginAddressId]);

    if (loading) return <div className="loading_content"><img src="./images/loading.gif" alt="" /></div>;

    return (
        <Layout>
            <ToastContainer
                position="top-right"
                className="toaster"
                autoClose={1500}
                hideProgressBar={true}
                pauseOnHover={false}
                draggable={false}
            />
            <section className="same_space layout_main">
                <div className="container">
                    <div className="all_page_heading">
                        <h5 className="address_description">Delivery Address</h5>
                    </div>
                    <div className="row mt-lg-4 mt-0">
                        <div className="col-xl-8 col-md-7 col-12 pb-4 mb-4">
                            <SelectedAddress userAddressByLoginAddressId={userAddressByLoginAddressId} />
                        </div>
                        <div className="d-flex justify-content-center col-xl-4 col-md-5 col-12 mb-4">
                            <CheckoutOrderSummary
                                subtotal={subtotal}
                                discountAmount={discountAmount}
                                totalAmount={totalAmount}
                                discountApplied={discountApplied}
                                projectPaymentGateway={projectPaymentGateway}
                                handlePaymentMethodChange={handlePaymentMethodChange}
                                productFormData={productFormData}
                                loading={loading}
                                onCreateOrder={onCreateOrder}
                                removeCoupon={removeCoupon}
                                setCouponCode={setCouponCode}
                                couponCode={couponCode}
                                applyCoupon={getCouponCode}
                                setDiscountApplied={setDiscountApplied}
                                customReqId={customReqId}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default Checkout;